// topic du plugin suivi : https://ckeditor.com/docs/ckeditor5/latest/framework/plugins/abbreviation-plugin/abbreviation-plugin-level-1.html

// Doc Model et View : https://ckeditor.com/docs/ckeditor5/latest/framework/architecture/editing-engine.html#view

// NOTIONS IMPORTANTES :
// - schema (pour les balises)
// - model (Le document modèle est converti en vue, qui représente le contenu que l'utilisateur est en train de modifier)
// - view (La View prend le Model et le converti en HTML et vice versa)
// - converters ("La passerelle" qui dit à l'éditeur comment convertir nos attributs déclarés dans le Model en element Html et vice versa Model -> View et View -> Model)
// - command (pour les boutons)

import Plugin from '@ckeditor/ckeditor5-core/src/plugin';
import ButtonView from '@ckeditor/ckeditor5-ui/src/button/buttonview';
import Icon from './embed.svg'

import '../styles.css';

export default class LSEmbed extends Plugin {

    init() {

        // on récupère l'objet editor de l'éditeur
        const editor = this.editor;

        // sur la propriété ui l'éditeur on invoque la compenentFactory pour créer un bouton
        editor.ui.componentFactory.add('ls_embed', locale => { // 'ls_embed' est le nom du bouton à déclarer dans la barre d'outils de l'éditeur

            // on crée un bouton
            const button = new ButtonView( locale );

            // on défini le label du bouton
            button.set({
                label: 'Insérer un contenu embarqué (iframe - Map - Youtube - ...)',
                icon: Icon,
                //withText: true,
                tooltip: true
            });

            // on écoute l'événement de click sur le bouton et on invoque la fonction _fetchBloc()
            this.listenTo( button, 'execute', () => {

                this._make_form(); 
        
            } );

            // on retourne le bouton
            return button;

        });

    }

    // Création du formulaire dans le DOM
    _make_form() {

        // décommenter si on veut fermer le modal sur click en dehors du modal
        // this._closeModalOnWindowClick();

        // get the dialog
        let dialog = document.getElementById('ckPluginsDialog');

        // Si le dialog n'existe pas, on le crée
        if (!dialog) {
            dialog = document.createElement('dialog');
            dialog.setAttribute('id', 'ckPluginsDialog');
            dialog.classList.add('ckPluginsDialog');
            document.body.appendChild(dialog);
        }

        // empty the dialog before adding new content
        dialog.innerHTML = '';
        // display the dialog 
        dialog.showModal();
        // create a form with a select and a button to submit
        let form = document.createElement('form');
            form.setAttribute('id', 'form');
            form.classList.add('dialog_form');
        // create textarea label
        let textareaLabel = document.createElement('label');
            textareaLabel.setAttribute('for', 'ls_embed_textarea');
            textareaLabel.classList.add('form-label');
            textareaLabel.innerText = 'Coller le code à insérer.';
        // create textarea
        let textarea = document.createElement('textarea');
            textarea.setAttribute('id', 'ls_embed_textarea');
            textarea.classList.add('dialog_textarea', 'form-control', 'mb-3');
        // add instructions to textarea
        textarea.placeholder = 'Exemple:\n<iframe src="https://www.youtube.com/embed/VIDEO_ID" width="560" height="315" frameborder="0" allowfullscreen></iframe>';
        //  create width input label
        let widthLabel = document.createElement('label');
            widthLabel.setAttribute('for', 'element_width');
            widthLabel.classList.add('form-label');
            widthLabel.innerText = 'Largeur d\'affichage en pixel';
        // create a input for map witdh
        let width = document.createElement('input');
            width.setAttribute('type', 'number');
            width.setAttribute('id', 'element_width');
            width.classList.add('form-control', 'mb-3');
            width.placeholder = "Exemple : 560";
        // create height input label
        let heightLabel = document.createElement('label');
            heightLabel.setAttribute('for', 'element_height');
            heightLabel.innerText = 'Hauteur d\'affichage en pixel';
        // create a input for map height
        let height = document.createElement('input');
            height.setAttribute('type', 'number');
            height.setAttribute('id', 'element_height');
            height.classList.add('form-control', 'mb-3');
            height.placeholder = "Exemple : 300";

        // create a submit button
        let submitBtn = document.createElement('button');
            submitBtn.setAttribute('type', 'submit');
            submitBtn.classList.add('btn', 'btn-sm', 'btn-primary');
            submitBtn.innerText = 'Valider';
        // create a cancel button
        let cancelBtn = document.createElement('button');
            cancelBtn.setAttribute('type', 'reset');
            cancelBtn.classList.add('btn', 'btn-sm', 'btn-secondary');
            cancelBtn.innerText = 'Fermer';
        // on click on cancel button
        cancelBtn.addEventListener('click', () => {
        dialog.style.display = 'none';
        dialog.close();
        });

        // append all Elements to Form
        form.append(textareaLabel, textarea, widthLabel, width, heightLabel, height, submitBtn, cancelBtn);
        // append form to dialog 
        dialog.appendChild(form);
        // display the dialog
        dialog.style.display = 'block';

        // action submit on form call _addSelectedBlocToWriter() then clean and close the dialog
        form.addEventListener('submit', (e) => {
            e.preventDefault();
            // insert the bloc in the editor
            this._addSelectedBlocToWriter();
            // clean and close the dialog
            dialog.style.display = 'none';
            dialog.close();
        });
    }
    // get selected option and insert it in the editor 
    _addSelectedBlocToWriter() {

        const stringToAdd = document.getElementById('ls_embed_textarea').value;
        const width = document.getElementById('element_width').value;
        const height = document.getElementById('element_height').value;
        let finalString = '';

        // si j'ai pas de width et height je ne fais rien
        if (!width || !height) {
            finalString = stringToAdd;
        } else {
            // Remplacer toutes les valeurs de width et height de la balise iframe par les valeurs saisies dans les inputs
            finalString = stringToAdd.replaceAll(/width="(\d+)"/g, 'width="' + width + '"')
                .replaceAll(/height="(\d+)"/g, 'height="' + height + '"');
                                        //  ou sinon pour remplacer une seule fois :
                            // .replace(/width="(\d+)"/, 'width="' + width.value + '"')
                            // .replace(/height="(\d+)"/, 'height="' + height.value + '"')
        }
        
        const div = document.createElement('div');
        div.classList.add('container', 'ls_embed');
        div.style.textAlign = 'center'; // on centre parce que la div n'existe encore pas dans le DOM à ce moment là.
        // injecte la string traitée dans la div
        div.innerHTML = finalString;

        // on récupère l'objet editor de l'éditeur
        const editor = this.editor;
        // injecte le code html de la div dans l'éditeur avec la commande htmlEmbed de Ck 
        // et outerHTML pour récupérer le code html de la div
        // avec tous ses attributs et son contenu.
        
        // editor.execute('htmlEmbed', div.outerHTML )

        const viewFragment = editor.data.processor.toView( div.outerHTML );
        const modelFragment = editor.data.toModel( viewFragment );

        editor.model.insertContent( modelFragment );
    }

    _closeModalOnWindowClick() {
        // close modal on click outside the modal
        window.addEventListener('click', (e) => {
        let dialog = document.getElementById('dialog');
        if (e.target == dialog) {
            dialog.style.display = 'none';
            dialog.close();
        }
    });
    }

}
